import React, {Fragment, useContext} from 'react';
import "./about.css";
import Facebook from '../../assets/fb.jpg';
import YouTube from '../../assets/yt.jpg';
import Twitter from '../../assets/tw.jpg';
import Gmail from '../../assets/Gmail1.jpg';
import Instagram from '../../assets/ig.jpg';
import { AuthorizationContext } from '../../context/authorizationContext';

const About = ()=>{

    const { setPath } = useContext(AuthorizationContext);
    setPath(window.location.pathname);

    return (
        <Fragment>
            <div class="about">
        <h2>About Us</h2>
        <p>
            On-board Employee Management System is service provider MERN stack application.
        </p>
        <p>
            It is a web app that provides services such as tracing work, assigning tasks to employees, etc.
        </p>
        <p>
            Admin have aunthentication to assign , track work and manage work of employees.
        </p>
        <p>
            This app may help such startup and companies to manage their work with employees of that company.
        </p>
        <p>
            result of this app will be transparent to each employee in the company so that progress of work can be measured easily.
        </p>
    </div>

    <footer class="foot">

        <h2>On-Board Empployee Management System</h2>

        <div id="details">
            <div class="info">
                <h3>Company</h3>
                <hr />
                <a href="/">Home</a>
                <a href="/">Let's Connect</a>
                <a href="/">Get Started</a>
            </div>

            <div class="info">
                <h3>Developers info</h3>
                <hr />
                <select name="" id="">
                    <option value="">Keyur Vataliya</option>
                    <option value="">Front-end and Testing</option>
                    <option value="">keyurvataliya1511@gmail.com</option>
                    <option value="">+91 9723334460</option>
                </select>

                <select name="" id="">
                    <option value="">Harshil Chudasama</option>
                    <option value="">Front-end and Back-end</option>
                    <option value="">harshil4821@gmail.com</option>
                    <option value="">+91 9723334460</option>
                </select>

                <select name="" id="">
                    <option value="">Mihir Vaghela</option>
                    <option value="">Front-end and Testing</option>
                    <option value="">mihir@gmail.com</option>
                    <option value="">+91 9723334460</option>
                </select>

                <select name="" id="">
                    <option value="">Ayush Prajapati</option>
                    <option value="">Database and Analysis</option>
                    <option value="">aush@gmail.com</option>
                    <option value="">+91 9723334460</option>
                </select>
            </div>

            <div class="info">
                <div class="social">
                    <a href="/"><img src={Facebook} alt="" /></a>
                    <a href="/"><img src={Instagram} alt="" /></a>
                    <a href="/"><img src={Twitter} alt="" /></a>
                    <a href="/"><img src={YouTube} alt="" /></a>
                    <a href="/"><img src={Gmail} alt="" /></a>
                </div>
            </div>
        </div>

        <div class="copy-right">
            Copyright &#169; 2022 On-board. All Rights Reserved.
        </div>
    </footer>
        </Fragment>
    )
};

export default About;